import axios from "axios";

export interface HeaderAuthAxios {
  userId?: string | null;
  token?: string | null;
  accountId?: string | null;
  userOrgaId?: string | null;
}

export default function setAuthHeaderAxios(
  headersAuth: HeaderAuthAxios | null
) {

  if (!headersAuth) {
    delete axios.defaults.headers.common["userID"];
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["user_orga_id"];
    delete axios.defaults.headers.common["User-Orga-Id"];
    return;
  }

  if (headersAuth?.userId) {
    axios.defaults.headers.common["userID"] = headersAuth.userId;
  }

  if (headersAuth?.token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${headersAuth.token}`;
  }

  if (headersAuth?.userOrgaId) {
    axios.defaults.headers.common["user_orga_id"] = headersAuth.userOrgaId;
    axios.defaults.headers.common["User-Orga-Id"] = headersAuth.userOrgaId;
  }
}
